module.exports = __webpack_public_path__ + "img/rayscom-blue-footer.421c2b53.svg";